import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import _get from 'lodash/get';
import { useForm } from 'utils/hooks';
import { fetchListOptions } from 'store/lists/actions';
import { createIndex, updateIndex } from 'store/market-indexes/actions';
import { strToNumber } from 'common/utils/numbers';
import config from './config';
import Body from './Body';
import Footer from './Footer';
import { selectListDefaultOptions } from 'store/lists/selectors';
import { FormBody } from 'common/components/drawer';

const EditIndex = ({ drawer, active, isOpen, refetchData }) => {
  const [disabled, setDisabled] = useState(false);
  const { formState, loadValues, resetForm, collectValues, handleSubmitError } = useForm(config);
  const dispatch = useDispatch();

  const marketIndexTypes = useSelector(state =>
    selectListDefaultOptions(state, 'market-index-types')
  ).map(type => ({
    ...type,
    label: type.name
  }));

  useEffect(() => {
    if (isOpen) {
      if (active) loadValues({ ...active });
      else resetForm();
    }
  }, [active, isOpen, loadValues, resetForm]);

  useEffect(() => {
    dispatch(fetchListOptions('market-index-types'));
  }, [dispatch]);

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    try {
      setDisabled(true);

      const { vessel_subtype, type, values_editable_by, ...rest } = values;

      if (values_editable_by === undefined) return;

      const params = {
        ...rest,
        vessel_subtype,
        type: {
          id: values.type_id,
          name: marketIndexTypes.find(m => m.id === strToNumber(values.type_id)).name
        },
        vessel_subtype_id: _get(vessel_subtype, 'id', null) || null,
        values_editable_by_id: values_editable_by?.id || null
      };

      if (active?.id) {
        await dispatch(updateIndex({ table: 'market-indexes', ...params, id: active.id }));
      } else {
        await dispatch(createIndex(params));
      }

      drawer.close();
      setDisabled(false);
      refetchData();
    } catch (error) {
      console.log(error);
      setDisabled(false);
      handleSubmitError(error);
    }
  };

  return (
    <>
      <FormBody>
        <Body formState={formState} marketIndexTypes={marketIndexTypes} />
      </FormBody>
      <Footer drawer={drawer} submit={submit} disabled={disabled} isCreating={!active?.id} />
    </>
  );
};

export default EditIndex;
